import { Pipe, PipeTransform } from '@angular/core';
import { intervalToDuration } from 'date-fns';

@Pipe({
  name: 'formatSecondsToHumanize'
})
export class FormatSecondsToHumanizePipe implements PipeTransform {

  transform(seconds: number): string {
    const duration = intervalToDuration({ start: 0, end: seconds * 1000 });

    const formattedDuration = [];

    if (duration.years) formattedDuration.push(`${duration.years}r`);
    if (duration.months) formattedDuration.push(`${duration.months}msc`);
    if (duration.days) formattedDuration.push(`${duration.days}d`);
    if (duration.hours) formattedDuration.push(`${duration.hours}h`);
    if (duration.minutes) formattedDuration.push(`${duration.minutes}min`);
    if (duration.seconds) formattedDuration.push(`${duration.seconds}s`);

    return formattedDuration.join(' ');
  }

}
